module.exports = __webpack_public_path__ + "7e30f0678c0d4121a2075674db944706.png";


//////////////////
// WEBPACK FOOTER
// ./components/applications/income/finicity_logo.png
// module id = 1099
// module chunks = 0